import { ValueOfKey } from '../../../utils-types';

export const SELF_BILLING_PAYMENT_STATUS = {
  ACTIVE: 'ACTIVE',
  CARD_REQUIRED: 'CARD_REQUIRED',
  PAYMENT_REQUIRED: 'PAYMENT_REQUIRED',
  CARD_AND_PAYMENT_REQUIRED: 'CARD_AND_PAYMENT_REQUIRED',
} as const;

export type SelfBillingPaymentStatus = ValueOfKey<typeof SELF_BILLING_PAYMENT_STATUS>;
